import { useSelector, shallowEqual } from 'react-redux';

import { selectValidationRequired } from 'state/meterpoint-validation/meterpoint-validation-slice';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import { useNavigation } from 'hooks/useNavigation';

export const MeterpointGuideCta = () => {
  const { electricity, gas } = useSelector(
    selectValidationRequired,
    shallowEqual
  );
  const { next, eventTypes } = useNavigation();

  const typeParams: string[] = [];
  electricity && typeParams.push('MPAN');
  gas && typeParams.push('MPRN');

  const type = typeParams.join('-') || 'MPAN-MPRN';

  const handleGoNext = () => {
    next({ eventType: eventTypes.GUIDE_CLICK, routeParams: { type } });
  };

  return (
    <NsSecondaryCta onClick={handleGoNext} icon="">
      See our guide
    </NsSecondaryCta>
  );
};
